import AdminRequestForApproval from "../Admin/Home/Pages/AdminAudition/AdminRequestForApproval/AdminRequestForApproval";
import InstructionSendFeedback from "../Admin/Home/Pages/AdminAudition/InstructionSendFeedback/InstructionSendFeedback";
import CreateCertificate from "../Admin/Home/Pages/AdminAudition/AuditionDasboard/Content/Certificate/CreateCertificate";
import RequestCertificate from "../Admin/Home/Pages/AdminAudition/AuditionDasboard/Content/Certificate/RequestCertificate";
import EventRequestApproval from "../Admin/Home/Pages/AdminAudition/AuditionDasboard/Content/Event/EventRequestApproval";
import EventsLive from "../Admin/Home/Pages/AdminAudition/AuditionDasboard/Content/Event/EventsLive";
import AuditionForFilterVideo from "../Admin/Home/Pages/AdminAudition/AuditionDasboard/Content/Event/AuditionForFilterVideo";
import AuditionForDistributeVideo from "../Admin/Home/Pages/AdminAudition/AuditionDasboard/Content/Event/AuditionForDistributeVideo";
import PendingEventAudition from "../Admin/Home/Pages/AdminAudition/AuditionDasboard/Content/Event/PendingEventAudition";
import RegisterAuditonList from "../Admin/Home/Pages/AdminAudition/AuditionDasboard/Content/Register/RegisterAuditonList";
import RegisterUserListAudition from "../Admin/Home/Pages/AdminAudition/AuditionDasboard/Content/Register/RegisterUserListAudition";
import DashboardAudition from "../Admin/Home/Pages/AdminAudition/AuditionDasboard/DashboardAudition";
import AdminAudition2 from "./AdminAudition2";
import AdminAuditionLive from "./AdminAuditionLive/AdminAuditionLive";
import AdminAuditionLiveVideoFilter from "./AdminAuditionLiveVideoFilter/AdminAuditionLiveVideoFilter";
import AdminAuditionRoundThree from "./AdminAuditionRoundThree/AdminAuditionRoundThree";
import AdminAuditionVideo from "./AdminAuditionVideo/AdminAuditionVideo";
import AdminAuditionVideoShow from "./AdminAuditionVideoShow/AdminAuditionVideoShow";
import AdminAuditionVideoShow2 from "./AdminAuditionVideoShow/AdminAuditionVideoShow2";
import AdminRoundOneAppeal from "./AdminRoundOneAppeal/AdminRoundOneAppeal";
import AuditionAssignedStar from "./AuditionAssignedStar/AuditionAssignedStar";
import AuditionFinalResult from "./AuditionFinalResult/AuditionFinalResult";
import AuditionSelectionRound from "./AuditionSelectionRound/AuditionSelectionRound";
import AuditionRounds from "./AuditonRounds/AuditionRounds";
import AuditionRoundsOld from "./AuditonRounds/AuditionRoundsOld";
import GrandFinish from "./Dashboard/Content/Finish/GrandFinish";
import PendingAudition from "./PendingAudition/PendingAudition";
import PostContentMaking from "./PostContentMaking/PostContentMaking";
import StartApprovalUpdate from "./StartApprovalUpdate/StartApprovalUpdate";

import RoundVideoResult from "./Event/RoundVideoResultOne/RoundVideoResult";
import RoundVideoResultTwo from "./Event/RoundVideoResultTwo/RoundVideoResultTwo";
import RoundVideoResultThree from "./Event/RoundVideoResultThree/RoundVideoResultThree";
import RoundVideoResultFour from "./Event/RoundVideoResultFour/RoundVideoResultFour";
import RoundVideoResultFive from "./Event/RoundVideoResultFive/RoundVideoResultFive";
import RoundVideoResultSix from "./Event/RoundVideoResultSix/RoundVideoResultSix";

import PendingAuditionDetails from "../Audition_static/Audition_admin/PendingAuditionDetails";
import AuditiionRoundInstruction from "./AuditonRounds/AuditiionRoundInstruction";
import AuditiionRoundInstructionDetails from "./AuditonRounds/AuditiionRoundInstructionDetails";
import AuditiionRoundVideoFilter from "./AuditonRounds/AuditiionRoundVideoFilter";
import AuditiionRoundVideoDistribute from "./AuditonRounds/AuditiionRoundVideoDistribute";
import StarRoundInstructionFeedback from "./StartApprovalUpdate/StarRoundInstructionFeedback";
import AuditionJuryMarkedVideos from "../Admin/Home/Pages/AdminAudition/AuditionDasboard/Content/Event/AuditionJuryMarkedVideos";
import AuditionJuryMarkedVideoByRound from "./AuditonRounds/AuditionJuryMarkedVideoByRound";
import AuditionRoundAssessmentResult from "./AuditonRounds/AuditionRoundAssessmentResult";
import PromoEvent from "../Admin/Home/Pages/AdminAudition/AuditionDasboard/Content/Event/PromoEvent";
import PromoCreate from "./PostContentMaking/PromoCreate";
import RoundInstructionCreate from "./PostContentMaking/RoundInstructionCreate";
import SuperStarPromoCreate from "./PostContentMaking/SuperStarPromoCreate";
import StarPromoFeedback from "../Admin/Home/Pages/AdminAudition/AuditionDasboard/Content/Event/StarPromoFeedback";
import PromoList from "../Admin/Home/Pages/AdminAudition/AuditionDasboard/Content/Event/PromoList";
import RoundInstructionList from "../Admin/Home/Pages/AdminAudition/AuditionDasboard/Content/Event/RoundInstructionList";
import ViewPromoList from "../Admin/Home/Pages/AdminAudition/InstructionSendFeedback/ViewPromoList";
import PostList from "../Admin/Home/Pages/AdminAudition/AuditionDasboard/Content/Event/PostList";

import CreatePost from "./PostContentMaking/CreatePost";
import CreatePromo from "./PromotionalVideo/CreatePromo";
import PromotionalList from "./PromotionalVideo/PromotionalList";
import AcceptedPromotionalList from "./PromotionalVideo/AcceptedPromotionalList";
import PrmotionalVideoView from "./PromotionalVideo/PrmotionalVideoView";
import PrmotionalVideoAcceptedView from "./PromotionalVideo/PrmotionalVideoAcceptedView";
import AuditionMainDashboard from "../Audition_static/Audition_admin/AuditionMainDashboard/AuditionMainDashboard";
import AuditionSingleSchedule from "../Audition_static/Audition_admin/AuditionMainDashboard/Screen/AuditionSingleSchedule";
import ScheduleTableCard from "../Audition_static/Audition_admin/AuditionMainDashboard/Screen/ScheduleTableCard";
import AuditionProfile from "./settings/AuditionProfile";
import Settings from "../Admin/MainDashboard/Reuse/Settings";
import RoundInstructionVideoCreate from "./PostContentMaking/RoundInstructionVideoCreate";
import AuditiionRoundInstructionVideoDetails from "./AuditonRounds/AuditiionRoundInstructionVideoDetails";
import RoundInstructionVideoAcceptList from "../Admin/Home/Pages/AdminAudition/AuditionDasboard/Content/Event/RoundInstructionVideoAcceptList";
import RoundInstructionVideoList from "../Admin/Home/Pages/AdminAudition/AuditionDasboard/Content/Event/RoundInstructionVideoList";
import RegisterUserListOnlineAudition from "../Admin/Home/Pages/AdminAudition/AuditionDasboard/Content/Online Round/RegisterUserListOnlineAudition";
import RegisteredTable from "../Admin/Home/Pages/AdminAudition/AuditionDasboard/Content/Register/RegisteredTable";
import ReactCountsTable from "../Admin/Home/Pages/AdminAudition/AuditionDasboard/Content/Register/ReactCountsTable";
import ReactCountListAudition from "../Admin/Home/Pages/AdminAudition/AuditionDasboard/Content/Register/ReactCountListAudition";

const AuditionAdminRoute = [
  {
    path: "/audition-admin/dashboard",
    exact: true,
    name: "dashboard",
    component: AuditionMainDashboard,
  },

  // Profile
  {
    path: "/audition-admin/profile",
    exact: true,
    name: "profile",
    component: AuditionProfile,
  },
  {
    path: "/audition-admin/profile-settings",
    exact: true,
    name: "profile",
    component: Settings,
  },

  {
    path: "/audition-admin/schedule",
    exact: true,
    name: "schedule",
    component: AuditionSingleSchedule,
  },

  {
    path: "/audition-admin/schedule/single/:id/:type",
    exact: true,
    name: "schedule",
    component: ScheduleTableCard,
  },

  {
    path: "/audition-admin/audition/event/pending",
    exact: true,
    name: "pending",
    component: PendingEventAudition,
  },
  {
    path: "/audition-admin/audition/create-post",
    exact: true,
    name: "create-post",
    component: CreatePost,
  },
  {
    path: "/audition-admin/audition/post-list",
    exact: true,
    name: "post-list",
    component: PostList,
  },
  {
    path: "/audition-admin/auditions/round1-appeal",
    exact: true,
    name: "grand-final",
    component: AdminRoundOneAppeal,
  },
  {
    path: "/audition-admin/auditions/finish",
    exact: true,
    name: "grand-final",
    component: GrandFinish,
  },
  {
    path: "/audition-admin/audition",
    exact: true,
    name: "audition",
    component: AdminAudition2,
  },
  {
    path: "/audition-admin/audition/live-upload-show/:id",
    exact: true,
    name: "audition",
    component: AdminAuditionLiveVideoFilter,
  },
  {
    path: "/audition-admin/audition/pending",
    exact: true,
    name: "audition-pending",
    component: PendingAudition,
  },
  {
    path: "/audition-admin/audition/promo-list",
    exact: true,
    name: "promo-list",
    component: PromoList,
  },
  {
    path: "/audition-admin/round-instruction-list",
    exact: true,
    name: "RoundInstructionList",
    component: RoundInstructionList,
  },
  {
    path: "/audition-admin/audition/view-promo-list/:id",
    exact: true,
    name: "view-promo-list",
    component: ViewPromoList,
  },
  {
    path: "/audition-admin/promo/create",
    exact: true,
    name: "promo-create",
    component: PromoCreate,
  },
  {
    path: "/audition-admin/round-instruction-create",
    exact: true,
    name: "roundInstructionCreate",
    component: RoundInstructionCreate,
  },
  {
    path: "/audition-admin/promo/super-star-create",
    exact: true,
    name: "super-star-promo-create",
    component: SuperStarPromoCreate,
  },
  {
    path: "/audition-admin/promotional/video-create",
    exact: true,
    name: "promotional-video-create",
    component: CreatePromo,
  },
  {
    path: "/audition-admin/promotional/video-list",
    exact: true,
    name: "promotional-video-list",
    component: PromotionalList,
  },
  {
    path: "/audition-admin/promotional/accepted/video-list",
    exact: true,
    name: "promotional-video-list",
    component: AcceptedPromotionalList,
  },
  {
    path: "/audition-admin/promotional/accepted/video-view/:id",
    exact: true,
    name: "promotional-video-list",
    component: PrmotionalVideoAcceptedView,
  },
  {
    path: "/audition-admin/promotional/video-view/:id",
    exact: true,
    name: "promotional-video-list",
    component: PrmotionalVideoView,
  },
  {
    path: "/audition-admin/audition/promo-instruction",
    exact: true,
    name: "promo-instruction",
    component: PromoEvent,
  },
  {
    path: "/audition-admin/audition/star-promo-feedback",
    exact: true,
    name: "star-promo-feedback",
    component: StarPromoFeedback,
  },
  {
    path: "/audition-admin/audition/star-promo-send-feedback/:slug",
    exact: true,
    name: "instructionSendFeedback",
    component: InstructionSendFeedback,
  },
  {
    path: "/audition-admin/audition/live",
    exact: true,
    name: "audition-pending",
    component: AdminAuditionLive,
  },
  {
    path: "/audition-admin/audition/audition-video/:id",
    exact: true,
    name: "audition-video",
    component: AdminAuditionVideo,
  },
  {
    path: "/audition-admin/audition/audition-video-show",
    exact: true,
    name: "audition-video-show",
    component: AdminAuditionVideoShow,
  },
  {
    path: "/audition-admin/audition/audition-video-show2",
    exact: true,
    name: "audition-video-show2",
    component: AdminAuditionVideoShow2,
  },
  {
    path: "/audition-admin/audition/selection-round",
    exact: true,
    name: "participant-list",
    component: AuditionSelectionRound,
  },
  {
    path: "/audition-admin/audition/assigned-star",
    exact: true,
    name: "participant-list",
    component: AuditionAssignedStar,
  },
  {
    path: "/audition-admin/audition/round-result",
    exact: true,
    name: "participant-list",
    component: AdminAuditionRoundThree,
  },
  {
    path: "/audition-admin/audition/final-result",
    exact: true,
    name: "participant-list",
    component: AuditionFinalResult,
  },
  {
    path: "/audition-admin/audition",
    exact: true,
    name: "audition",
    component: AdminAudition2,
  },
  {
    path: "/audition-admin/audition/pending",
    exact: true,
    name: "audition-pending",
    component: PendingAudition,
  },
  {
    path: "/audition-admin/audition/promo-list",
    exact: true,
    name: "promo-list",
    component: PromoList,
  },
  {
    path: "/audition-admin/audition/view-promo-list/:id",
    exact: true,
    name: "view-promo-list",
    component: ViewPromoList,
  },
  {
    path: "/audition-admin/audition/promo-instruction",
    exact: true,
    name: "promo-instruction",
    component: PromoEvent,
  },
  {
    path: "/audition-admin/audition/star-promo-feedback",
    exact: true,
    name: "star-promo-feedback",
    component: StarPromoFeedback,
  },
  {
    path: "/audition-admin/audition/star-promo-send-feedback/:slug",
    exact: true,
    name: "instructionSendFeedback",
    component: InstructionSendFeedback,
  },
  {
    path: "/audition-admin/audition/round-result",
    exact: true,
    name: "participant-list",
    component: AdminAuditionRoundThree,
  },
  {
    path: "/audition-admin/audition/final-result",
    exact: true,
    name: "participant-list",
    component: AuditionFinalResult,
  },

  {
    path: "/audition-admin/audition/dashboard",
    exact: true,
    name: "dashboard",
    component: DashboardAudition,
  },
  {
    path: "/audition-admin/audition/event",
    exact: true,
    name: "event",
    component: EventsLive,
  },
  {
    path: "/audition-admin/audition/filter-videos",
    exact: true,
    name: "event",
    component: AuditionForFilterVideo,
  },
  {
    path: "/audition-admin/audition/jury-marked-videos",
    exact: true,
    name: "AuditionJuryMarkedVideos",
    component: AuditionJuryMarkedVideos,
  },
  {
    path: "/audition-admin/audition/distribute-videos",
    exact: true,
    name: "event",
    component: AuditionForDistributeVideo,
  },
  {
    path: "/audition-admin/audition/event/request-approve",
    exact: true,
    name: "pending",
    component: EventRequestApproval,
  },
  {
    path: "/audition-admin/audition/event/request-approve/:slug",
    exact: true,
    name: "pending",
    component: AdminRequestForApproval,
  },

  {
    path: "/audition-admin/audition/round",
    exact: true,
    name: "participant-list",
    component: AuditionRoundsOld,
  },
  {
    path: "/audition-admin/audition/round-instruction/:slug",
    exact: true,
    name: "AuditiionRoundInstruction",
    component: AuditiionRoundInstruction,
  },
  {
    path: "/audition-admin/audition/round-instruction-details/:slug",
    exact: true,
    name: "AuditiionRoundInstructionDetails",
    component: AuditiionRoundInstructionDetails,
  },
  {
    path: "/audition-admin/audition/round-video-filter/:slug",
    exact: true,
    name: "AuditiionRoundVideoFilter",
    component: AuditiionRoundVideoFilter,
  },
  {
    path: "/audition-admin/audition/jury-marked-videos/:slug",
    exact: true,
    name: "AuditionJuryMarkedVideoByRound",
    component: AuditionJuryMarkedVideoByRound,
  },
  {
    path: "/audition-admin/audition/round-result/:slug",
    exact: true,
    name: "AuditionRoundAssessmentResult",
    component: AuditionRoundAssessmentResult,
  },
  {
    path: "/audition-admin/audition/round-video-distribute/:slug",
    exact: true,
    name: "AuditiionRoundVideoDistribute",
    component: AuditiionRoundVideoDistribute,
  },
  {
    path: "/audition-admin/audition/rounds/:audition_id",
    exact: true,
    name: "singleAuditionRounds",
    component: AuditionRounds,
  },
  {
    path: "/audition-admin/audition/certificate-create",
    exact: true,
    name: "certificate-create",
    component: CreateCertificate,
  },
  {
    path: "/audition-admin/audition/certificate-request",
    exact: true,
    name: "certificate-request",
    component: RequestCertificate,
  },
  {
    path: "/audition-admin/audition/register-user",
    exact: true,
    name: "certificate-request",
    component: RegisterUserListAudition,
  },
  {
    path: "/audition-admin/audition/participant-list/:id",
    exact: true,
    name: "registered-participant-list",
    component: RegisteredTable,
  },
  {
    path: "/audition-admin/audition/react-count-list",
    exact: true,
    name: "react-count",
    component: ReactCountListAudition,
  },
  {
    path: "/audition-admin/audition/react-count/:id",
    exact: true,
    name: "react-count-list",
    component: ReactCountsTable,
  },
  {
    path: "/audition-admin/audition/online-audition-round",
    exact: true,
    name: "online-audition-round",
    component: RegisterUserListOnlineAudition,
  },
  {
    path: "/audition-admin/audition/register-user-list",
    exact: true,
    name: "certificate-request",
    component: RegisterAuditonList,
  },

  {
    path: "/audition-admin/audition/post-content-making-for-star/:slug",
    exact: true,
    name: "post-content-making",
    component: PostContentMaking,
  },
  {
    path: "/audition-admin/audition/star-feedback-round-instruction/:slug",
    exact: true,
    name: "StarRoundInstructionFeedback",
    component: StarRoundInstructionFeedback,
  },
  {
    path: "/audition-admin/audition/start-approval-update",
    exact: true,
    name: "start-approval-update",
    component: StartApprovalUpdate,
  },
  {
    path: "/audition-admin/event/round-video-result",
    exact: true,
    name: "round-video-result",
    component: RoundVideoResult,
  },
  {
    path: "/audition-admin/event/round-video-result-two",
    exact: true,
    name: "round-video-result-two",
    component: RoundVideoResultTwo,
  },
  {
    path: "/audition-admin/event/round-video-result-three",
    exact: true,
    name: "round-video-result-three",
    component: RoundVideoResultThree,
  },
  {
    path: "/audition-admin/event/round-video-result-four",
    exact: true,
    name: "round-video-result-four",
    component: RoundVideoResultFour,
  },
  {
    path: "/audition-admin/event/round-video-result-five",
    exact: true,
    name: "round-video-result-five",
    component: RoundVideoResultFive,
  },
  {
    path: "/audition-admin/event/round-video-result-six",
    exact: true,
    name: "round-video-result-six",
    component: RoundVideoResultSix,
  },

  {
    path: "/audition-admin/statusBanner",
    exact: true,
    name: "audition-status",
    component: RoundVideoResultTwo,
  },
  {
    path: "/audition-admin/round-instruction-video-create",
    exact: true,
    name: "roundInstructionVideoCreate",
    component: RoundInstructionVideoCreate,
  },
  {
    path: "/audition-admin/round-instruction-video-list",
    exact: true,
    name: "RoundInstructionVideoList",
    component: RoundInstructionVideoList,
  },

  {
    path: "/audition-admin/round-instruction-video-accepted",
    exact: true,
    name: "RoundInstructionVideoAcceptList",
    component: RoundInstructionVideoAcceptList,
  },
  {
    path: "/audition-admin/audition/round-instruction-video-details/:id",
    exact: true,
    name: "AuditiionRoundInstructionVideoDetails",
    component: AuditiionRoundInstructionVideoDetails,
  },

  // Test Route
  {
    path: "/audition-admin/test",
    exact: true,
    name: "test",
    component: PendingAuditionDetails,
  },
];

export default AuditionAdminRoute;
